import { buildTransform } from './build-transform.mjs';
import { isCSSVariableName } from '../../dom/utils/is-css-variable.mjs';
import { transformProps } from './transform.mjs';
import { getValueAsType } from '../../dom/value-types/get-as-type.mjs';
import { numberValueTypes } from '../../dom/value-types/number.mjs';
function buildHTMLStyles(state, latestValues, transformTemplate) {
  var style = state.style,
    vars = state.vars,
    transformOrigin = state.transformOrigin;
  // Track whether we encounter any transform or transformOrigin values.
  var hasTransform = false;
  var hasTransformOrigin = false;
  /**
   * Loop over all our latest animated values and decide whether to handle them
   * as a style or CSS variable.
   *
   * Transforms and transform origins are kept separately for further processing.
   */
  for (var key in latestValues) {
    var value = latestValues[key];
    if (transformProps.has(key)) {
      // If this is a transform, flag to enable further transform processing
      hasTransform = true;
      continue;
    } else if (isCSSVariableName(key)) {
      vars[key] = value;
      continue;
    } else {
      // Convert the value to its default value type, ie 0 -> "0px"
      var valueAsType = getValueAsType(value, numberValueTypes[key]);
      if (key.startsWith("origin")) {
        // If this is a transform origin, flag and enable further transform-origin processing
        hasTransformOrigin = true;
        transformOrigin[key] = valueAsType;
      } else {
        style[key] = valueAsType;
      }
    }
  }
  if (!latestValues.transform) {
    if (hasTransform || transformTemplate) {
      style.transform = buildTransform(latestValues, state.transform, transformTemplate);
    } else if (style.transform) {
      /**
       * If we have previously created a transform but currently don't have any,
       * reset transform style to none.
       */
      style.transform = "none";
    }
  }
  /**
   * Build a transformOrigin style. Uses the same defaults as the browser for
   * undefined origins.
   */
  if (hasTransformOrigin) {
    var _transformOrigin$orig = transformOrigin.originX,
      originX = _transformOrigin$orig === void 0 ? "50%" : _transformOrigin$orig,
      _transformOrigin$orig2 = transformOrigin.originY,
      originY = _transformOrigin$orig2 === void 0 ? "50%" : _transformOrigin$orig2,
      _transformOrigin$orig3 = transformOrigin.originZ,
      originZ = _transformOrigin$orig3 === void 0 ? 0 : _transformOrigin$orig3;
    style.transformOrigin = "".concat(originX, " ").concat(originY, " ").concat(originZ);
  }
}
export { buildHTMLStyles };